export const BORROWER_NAME_FIELD_LABEL = 'Borrower name';
